import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import useMediaQuery from "@mui/material/useMediaQuery";
import { alpha } from "@mui/system/colorManipulator";
import Menu01Icon from "@untitled-ui/icons-react/build/esm/Menu01";
import { UserButton } from "../../user-button";
// import { ContactsButton } from "../contacts-button";
import { LanguageSwitch } from "../language-switch";
// import { NotificationsButton } from "../notifications-button";

import type { Theme } from "@mui/material/styles/createTheme";
import type { FC, ReactNode } from "react";
import { Typography } from "@mui/material";
import { useGetCurrentCompanyCache } from "~/queries/useGetCurrentCompany";
import { useSettings } from "~/hooks/use-settings";
const TOP_NAV_HEIGHT = 64;
interface TopNavProps {
  navpagetitle?: string;
  navfiltersitems?: ReactNode;
  onMobileNavOpen?: () => void;
}
export const TopNav: FC<TopNavProps> = props => {
  const {
    onMobileNavOpen,
    ...other
  } = props;
  const settings = useSettings();
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  const {
    data: company
  } = useGetCurrentCompanyCache();
  return <Box component="header" sx={{
    backdropFilter: "blur(6px)",
    backgroundColor: theme => alpha(theme.palette.background.default, 0.8),
    position: "sticky",
    top: 0,
    zIndex: theme => theme.zIndex.appBar
  }} {...other} data-sentry-element="Box" data-sentry-component="TopNav" data-sentry-source-file="top-nav.tsx">
			<Stack alignItems="center" direction="row" justifyContent="space-between" spacing={2} sx={{
      minHeight: TOP_NAV_HEIGHT,
      px: 2
    }} data-sentry-element="Stack" data-sentry-source-file="top-nav.tsx">
				<Stack alignItems="center" direction="row" spacing={2} sx={{
        width: "25%"
      }} data-sentry-element="Stack" data-sentry-source-file="top-nav.tsx">
					{lgUp && <Box sx={{
          backgroundColor: theme => theme.palette.mode === "dark" ? "neutral.800" : "neutral.100",
          borderRadius: 2.5,
          mt: 7,
          mx: 1
        }}>
							<Stack alignItems="center" direction="row" onClick={() => {
            void settings.handleOpenNavDrawer();
          }} spacing={1} sx={{
            cursor: "pointer",
            p: 2,
            userSelect: "none"
          }}>
								<SvgIcon color="action">
									<Menu01Icon />
								</SvgIcon>
							</Stack>
						</Box>}
					{!lgUp && <IconButton onClick={onMobileNavOpen}>
							<SvgIcon>
								<Menu01Icon />
							</SvgIcon>
						</IconButton>}
					<Typography variant="h4" data-sentry-element="Typography" data-sentry-source-file="top-nav.tsx">
						{props.navpagetitle ? props.navpagetitle === "Files" ? company?.fileAlias?.plural : props.navpagetitle : props.navpagetitle}
					</Typography>
				</Stack>
				<Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2} sx={{
        width: "75%"
      }} data-sentry-element="Stack" data-sentry-source-file="top-nav.tsx">
					{props.navfiltersitems}
					<LanguageSwitch data-sentry-element="LanguageSwitch" data-sentry-source-file="top-nav.tsx" />
					{/* <NotificationsButton /> */}
					{/* <ContactsButton /> */}
					<UserButton data-sentry-element="UserButton" data-sentry-source-file="top-nav.tsx" />
				</Stack>
			</Stack>
		</Box>;
};